//class
import PadCreator from '../PadCreator';
// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
// consts
import { TYPE } from 'app/config/prescription_content';
// form
// import { prescriptionTypeInitFormFn } from 'app/components/modals/pad-creator/PrescriptionModal/prescriptionForms/prescriptionTypeForm/utils/prescriptionTypeInitFormFn';
// import { prescriptionMedicamentInitFormFn } from 'app/components/modals/pad-creator/PrescriptionModal/prescriptionForms/prescriptionMedicamentForm/utils/prescriptionMedicamentInitFormFn';
// classes
import { PadPrescriptionType } from './PadPrescriptionType';

/**
 * represents an instance of PadPrescriptionMedicament
 * @class PadPrescriptionMedicament
 * @extends PadCreator
 */
export default class PadPrescriptionMedicament extends PadCreator {
  prepare(padPrescriptionMedicaments = []) {
    const preparedMedicaments = padPrescriptionMedicaments.map(padPrescriptionMedicament => {
      const code = codeGeneretor();
      const type = TYPE.SUSTEINED; // mantido
      const { prescriptionTypeForm, medicamentForm } = padPrescriptionMedicament;

      // const prescriptionTypeForm = prescriptionTypeInitFormFn(padPrescriptionMedicament);
      // const medicamentForm = prescriptionMedicamentInitFormFn(padPrescriptionMedicament);

      return {
        code,
        type,
        prescriptionTypeForm,
        medicamentForm
      };
    });

    this._loadedData = _.cloneDeep(preparedMedicaments);
    this._screenData = _.cloneDeep(preparedMedicaments);

    return this;
  }

  /**
   * insert a new medicament.
   * @param {object} medicament - new medicament.
   * @returns {object} the state
   */
  add(medicament) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(medicament);

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnAdd(padPrescription);

    padPrescription.type = type;
    padPrescription.code = codeGeneretor();

    this._screenData.push(padPrescription);

    return this;
  }

  /**
   * update a medicament.
   * @param {string} code - medicament`s code to be edited.
   * @param {object} medicament - medicament to be edited.
   * @returns {object} return the state
   */
  edit(code, medicament = {}) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(medicament);

    // find index by code
    const indexScreenToEdit = [...this._screenData].findIndex(item => item.code === code);

    Object.entries(padPrescription).forEach(([key, content]) => {
      this._screenData[indexScreenToEdit][key] = content;
    });

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnEdit(padPrescription);

    this._screenData[indexScreenToEdit].type = type;

    return this;
  }

  /**
   * remove a element.
   * @param {string} code - element`s code to remove.
   * @returns {object} return the state
   */
  remove(code) {
    const newScreen = [...this._screenData].filter(currentElement => currentElement.code !== code);

    this._screenData = newScreen;

    return this;
  }

  /**
   * suspend a pad prescription medicament.
   * @param {string} code - element`s code to suspend.
   * @returns {object} return the state
   */
  suspend(code) {
    const newScreen = [...this._screenData].map(currentElement => {
      if (currentElement.code === code) currentElement.type = TYPE.SUSPENDED;

      return {
        ...currentElement
      };
    });

    this._screenData = newScreen;

    return this;
  }

  /**
   * unsuspend a pad prescription medicament.
   * @param {string} code - element`s code to suspend.
   * @returns {object} return the state
   */
  unsuspend(code, prescriptionForm) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(prescriptionForm);

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnUnsuspend(padPrescription);

    const newScreen = [...this._screenData].map(currentElement => {
      if (currentElement.code === code) currentElement.type = type;

      return {
        ...currentElement
      };
    });

    this._screenData = newScreen;

    return this;
  }

  replacesAllPrescriptors(prescriptionForm) {
    const { medicamentForm } = prescriptionForm;
    const { professionalId, responsibleForPrescriptionName } = medicamentForm;

    const nScreen = [...this._screenData].map(prescription => {
      return {
        ...prescription,
        medicamentForm: {
          ...prescription.medicamentForm,
          professionalId: professionalId,
          responsibleForPrescriptionName: responsibleForPrescriptionName
          // formAddOn: {
          //   responsibleForPrescriptionId: professionalId
          // }
        }
      };
    });

    this._screenData = nScreen;
    this._state.data.screen = nScreen;

    return this;
  }
}
